/* Emoto — Půjčovna: termín, kalkulačka, jezdec s výstrojí.
   Mechanika i ceny 1:1 podle pujcovnavlasim.cz (Lukáš):
   - den / víkend (pá–po) / více dní, sleva z nájmu 3–4 dny −10 %, 5–7 −15 %, 8+ −20 %
   - výstroj se počítá na počet dní, u víkendu na 3 dny; všech 8 kusů = set (výhodnější)
   - vozík 800/den, víkend 2 000, přidává 5 000 ke kauci
   - kauce se násobí počtem kusů
   - vyzvednutí i vrácení jen v pracovní den (So/Ne, svátky a zavřeno nejdou vybrat)
   Ceny a nastavení přicházejí z JSON bloku #e-kalk-cfg (nastavení sekce), nic natvrdo. */
(function () {
  var korenKalk = document.getElementById('e-kalk');
  if (!korenKalk) return;

  /* ---------- ceny a nastavení z JSON bloku sekce (#e-kalk-cfg) ---------- */
  var C = { den: 3000, vikend: 7000, kauce: 10000, maxKs: 6, maxDni: 30, slevy: [], hodiny: { dop: [540, 720], odp: [780, 1020] }, zavreno: [], vystroj: [], vozik: { n: 'Vozík', p: 800, pw: 2000, kauce: 5000 }, nazev: 'Stark VARG EX' };
  try {
    var cfgEl = document.getElementById('e-kalk-cfg');
    var J = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    ['den', 'vikend', 'kauce', 'maxKs', 'maxDni', 'vystroj', 'vozik', 'nazev'].forEach(function (k) { if (J[k] != null) C[k] = J[k]; });
    /* slevy „3:10, 5:15, 8:20" */
    C.slevy = String(J.slevy || '').split(',').map(function (t) { var x = t.trim().split(':'); return { od: +x[0], pct: +x[1] }; }).filter(function (x) { return x.od > 0 && x.pct > 0; });
    /* hodiny „9:00-12:00, 13:00-17:00" */
    var hh = String(J.hodiny || '').split(',').map(function (t) { return t.trim().split('-').map(function (v) { var m = v.match(/(\d{1,2})[:.](\d{2})/); return m ? (+m[1]) * 60 + (+m[2]) : null; }); });
    if (hh[0] && hh[0][0] != null && hh[0][1] != null) C.hodiny.dop = hh[0];
    if (hh[1] && hh[1][0] != null && hh[1][1] != null) C.hodiny.odp = hh[1];
    /* zavřeno: řádek „RRRR-MM-DD" nebo „RRRR-MM-DD..RRRR-MM-DD" */
    C.zavreno = String(J.zavreno || '').split(/\r?\n/).map(function (t) { var x = t.trim().split('..'); return x[0] ? { od: x[0].trim(), do: (x[1] || x[0]).trim() } : null; }).filter(Boolean);
  } catch (e) { /* zůstanou výchozí */ }
  var slevy = C.slevy.slice().sort(function (a, b) { return b.od - a.od; });
  function sleva(n) { for (var i = 0; i < slevy.length; i++) { if (n >= slevy[i].od) return slevy[i].pct / 100; } return 0; }
  function kc(n) { return Math.round(n).toLocaleString('cs-CZ'); }
  function cenaKusu(id) { for (var i = 0; i < C.vystroj.length; i++) { if (C.vystroj[i].id === id) return C.vystroj[i].p; } return 0; }
  function nazevKusu(id) { for (var i = 0; i < C.vystroj.length; i++) { if (C.vystroj[i].id === id) return C.vystroj[i].n; } return id; }
  function dnyTxt(n) { return n + ' ' + (n === 1 ? 'den' : n < 5 ? 'dny' : 'dní'); }
  var SETP = cenaKusu('set') || 600;

  /* ---------- pracovní dny: So/Ne, státní svátky, zavřeno ---------- */
  function velikonocniNedele(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
      m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31),
      da = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, mo - 1, da);
  }
  var SVATKY = ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26'];
  function jeSvatek(d) {
    var md = (d.getUTCMonth() + 1) + '-' + d.getUTCDate();
    if (SVATKY.indexOf(md) >= 0) return true;
    var vn = velikonocniNedele(d.getUTCFullYear()), t = d.getTime();
    return t === vn - 2 * 864e5 || t === vn + 864e5;
  }
  function jeZavreno(d) {
    var isoD = d.toISOString().slice(0, 10);
    return C.zavreno.some(function (z) { return z && z.od && isoD >= z.od && isoD <= (z.do || z.od); });
  }
  function jePracovni(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5 && !jeSvatek(d) && !jeZavreno(d); }
  function naDatum(v) { var x = String(v || '').split('-').map(Number); return x.length === 3 ? new Date(Date.UTC(x[0], x[1] - 1, x[2])) : null; }
  function pracovni(v) { var d = naDatum(v); return !!d && jePracovni(d); }
  function svatek(v) { var d = naDatum(v); return !!d && jeSvatek(d); }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function plusDny(v, n) { var x = v.split('-').map(Number); return iso(new Date(x[0], x[1] - 1, x[2] + n)); }
  var DNY_K = ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'];
  function fmtD(v) {
    var x = String(v || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!x) return '';
    var d = new Date(+x[1], +x[2] - 1, +x[3]);
    return DNY_K[d.getDay()] + ' ' + (+x[3]) + '. ' + (+x[2]) + '.';
  }

  /* ---------- stav otevírací doby ---------- */
  function prahaNyni() {
    var p = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    function g(t) { return parseInt(p.find(function (x) { return x.type === t; }).value, 10); }
    return { den: new Date(Date.UTC(g('year'), g('month') - 1, g('day'))), min: (g('hour') % 24) * 60 + g('minute') };
  }
  function hhmm(m) { return Math.floor(m / 60) + ':' + String(m % 60).padStart(2, '0'); }
  var DNY_V = ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'];
  function stavOtevreno() {
    var n = prahaNyni(), D = C.hodiny.dop, O = C.hodiny.odp;
    if (jePracovni(n.den)) {
      if (n.min >= D[0] && n.min < D[1]) return { open: true, t: 'Právě máme otevřeno, do ' + hhmm(D[1]) };
      if (n.min >= O[0] && n.min < O[1]) return { open: true, t: 'Právě máme otevřeno, do ' + hhmm(O[1]) };
      if (n.min >= D[1] && n.min < O[0]) return { open: false, t: 'Polední pauza, volejte od ' + hhmm(O[0]) };
      if (n.min < D[0]) return { open: false, t: 'Otevíráme dnes v ' + hhmm(D[0]) };
    }
    var d = new Date(n.den.getTime() + 864e5), krok = 1;
    while (!jePracovni(d) && krok++ < 40) d = new Date(d.getTime() + 864e5);
    var kdy = krok === 1 ? 'zítra' : krok > 6 ? d.getUTCDate() + '. ' + (d.getUTCMonth() + 1) + '.' : DNY_V[d.getUTCDay()];
    return { open: false, t: 'Zavřeno, volejte ' + kdy + ' od ' + hhmm(D[0]) };
  }
  function vykresliStav() {
    var s = stavOtevreno();
    [].forEach.call(document.querySelectorAll('[data-open]'), function (el) {
      el.textContent = s.t;
      el.classList.toggle('je-otevreno', s.open);
      el.classList.toggle('je-zavreno', !s.open);
    });
  }
  vykresliStav();
  setInterval(vykresliStav, 60000);

  /* ---------- jezdec s výstrojí ---------- */
  var PTS = { bryle: [122, 95], helma: [190, 52], dres: [40, 300], hrudni: [200, 238], rukavice: [58, 412], kalhoty: [112, 600], kolena: [222, 702], boty: [238, 905] };
  var GL = ['bryle', 'dres', 'rukavice', 'kalhoty'], GR = ['helma', 'hrudni', 'kolena', 'boty'];
  var GALL = GL.concat(GR);
  var vybrano = [];
  var gearEl = document.getElementById('e-gear');
  var gearImg = document.getElementById('e-gear-img');

  function gearKresliPolozky() {
    function polozka(id) {
      return '<button type="button" class="e-gear__it" data-g="' + id + '" aria-pressed="false">' +
        '<span class="e-gear__txt"><b>' + nazevKusu(id) + '</b><em>' + kc(cenaKusu(id)) + ' Kč</em></span>' +
        '<span class="e-gear__tile">' + (GALL.indexOf(id) + 1) + '</span>' +
        '<i class="e-gear__ln" aria-hidden="true"></i></button>';
    }
    gearEl.querySelector('.e-gear__col--l').innerHTML = GL.map(polozka).join('');
    gearEl.querySelector('.e-gear__col--r').innerHTML = GR.map(polozka).join('');
  }
  function gearLinky() { /* linky jsou v CSS (krátká čárka s tečkou jako na poukazu) */ }
  function gearPrekresli() {
    [].forEach.call(gearEl.querySelectorAll('[data-g]'), function (el) {
      var on = vybrano.indexOf(el.dataset.g) >= 0;
      el.classList.toggle('je-on', on);
      if (el.tagName === 'BUTTON') el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function cenaVystroje() {
    var jednotlive = vybrano.reduce(function (s, id) { return s + cenaKusu(id); }, 0);
    var celySet = GALL.every(function (id) { return vybrano.indexOf(id) >= 0; });
    return { jednotlive: jednotlive, celySet: celySet, zaDen: celySet ? SETP : jednotlive, set: SETP };
  }
  gearKresliPolozky();
  gearEl.addEventListener('click', function (e) {
    var t = e.target.closest('[data-g]');
    if (!t) return;
    var id = t.dataset.g, i = vybrano.indexOf(id);
    if (i >= 0) vybrano.splice(i, 1); else vybrano.push(id);
    gearPrekresli(); gearLinky(); prepocti();
  });
  gearEl.addEventListener('mouseover', function (e) { var t = e.target.closest('[data-g]'); if (t) zvyrazni(t.dataset.g, true); });
  gearEl.addEventListener('mouseout', function (e) { var t = e.target.closest('[data-g]'); if (t) zvyrazni(t.dataset.g, false); });
  function zvyrazni(id, on) { [].forEach.call(gearEl.querySelectorAll('[data-g="' + id + '"]'), function (el) { el.classList.toggle('je-hl', on); }); }
  if (gearImg.complete) gearLinky(); else gearImg.addEventListener('load', gearLinky);
  window.addEventListener('resize', gearLinky);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(gearLinky);
  document.getElementById('e-gear-set').addEventListener('click', function () { vybrano = GALL.slice(); gearPrekresli(); gearLinky(); prepocti(); });
  document.getElementById('e-gear-zrus').addEventListener('click', function () { vybrano = []; gearPrekresli(); gearLinky(); prepocti(); });

  /* ---------- počet kusů ---------- */
  var ks = 1, setKsZapnut = false;
  var ksEl = document.getElementById('e-kalk-ks');
  ksEl.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-a]');
    if (!b) return;
    if (b.dataset.a === 'plus') ks = Math.min(C.maxKs, ks + 1);
    if (b.dataset.a === 'minus') ks = Math.max(1, ks - 1);
    if (ks === 1) setKsZapnut = false;
    vykresliKs(); prepocti();
  });
  function vykresliKs() {
    ksEl.querySelector('[data-pocet]').textContent = ks + ' ks';
    ksEl.querySelector('[data-a="minus"]').disabled = ks <= 1;
    ksEl.querySelector('[data-a="plus"]').disabled = ks >= C.maxKs;
    var setk = document.getElementById('e-kalk-setks');
    setk.hidden = ks < 2;
    setk.querySelector('input').checked = setKsZapnut;
  }
  document.getElementById('e-kalk-setks').querySelector('input').addEventListener('change', function (e) { setKsZapnut = e.target.checked; prepocti(); });

  /* ---------- délka a termín ---------- */
  var polOd = document.getElementById('e-od'), polDo = document.getElementById('e-do');
  function delka() { return (document.querySelector('input[name="e-len"]:checked') || {}).value || 'den'; }
  function pocetDni() {
    var d = delka();
    if (d === 'den') return 1;
    if (d === 'vikend') return 3;
    return Math.max(2, Math.min(C.maxDni, parseInt(document.getElementById('e-dny').value, 10) || 2));
  }
  function terminChyby() {
    var h = [], a = polOd.value, b = polDo.value, dnes = iso(new Date());
    if (a && a < dnes) h.push('Vyzvednutí je v minulosti, vyberte prosím jiný den.');
    if (a && !pracovni(a)) h.push('V tento den stroje nevydáváme (víkend, svátek nebo máme zavřeno). Víkendové půjčení: vyzvednutí v pátek 9–17, vrácení v pondělí do 10:00.');
    if (b && !pracovni(b)) h.push('Vracet se dá jen v pracovní den, u víkendu v pondělí do 10:00.');
    if (a && b && b <= a) h.push('Vrácení musí být až po vyzvednutí.');
    return h;
  }
  function vykresliTermin() {
    var h = terminChyby(), el = document.getElementById('e-kalk-hint');
    el.innerHTML = h.join('<br>');
    el.style.display = h.length ? 'block' : 'none';
    el.classList.toggle('je-chyba', h.length > 0);
    [].forEach.call(document.querySelectorAll('.e-dbtn'), function (b) {
      var v = document.getElementById('e-' + b.dataset.for).value;
      b.innerHTML = v ? '<b>' + fmtD(v).slice(0, 2) + '</b> ' + (+v.slice(8)) + '. ' + (+v.slice(5, 7)) + '. ' + v.slice(0, 4) : '<span>vyberte den</span>';
      b.classList.toggle('je-chyba', !!v && h.length > 0 && (!pracovni(v) || (b.dataset.for === 'do' && v <= polOd.value)));
    });
  }
  function dopocitejVraceni() {
    var a = polOd.value;
    if (!a) return;
    var d = delka(), od = a;
    if (d === 'vikend') {
      var x = a.split('-').map(Number), den = new Date(x[0], x[1] - 1, x[2]);
      od = plusDny(a, (5 - den.getDay() + 7) % 7);
      polOd.value = od;
    }
    var n = pocetDni(), cil = plusDny(od, n), v = cil, k = 0;
    while (!pracovni(v) && k++ < 14) v = plusDny(v, 1);
    polDo.value = v;
    vykresliTermin();
    if (v !== cil) srovnejDelku();
  }
  function srovnejDelku() {
    var a = polOd.value, b = polDo.value;
    if (!a || !b) return;
    var d1 = new Date(a), d2 = new Date(b), n = Math.round((d2 - d1) / 864e5);
    if (n < 1) return;
    if (d1.getDay() === 5 && d2.getDay() === 1 && n === 3) document.querySelector('input[name="e-len"][value="vikend"]').checked = true;
    else if (n === 1) document.querySelector('input[name="e-len"][value="den"]').checked = true;
    else { document.querySelector('input[name="e-len"][value="vice"]').checked = true; document.getElementById('e-dny').value = n; }
  }
  [].forEach.call(document.querySelectorAll('input[name="e-len"]'), function (i) {
    i.addEventListener('change', function () { dopocitejVraceni(); prepocti(); });
  });
  document.getElementById('e-dny').addEventListener('input', function () {
    document.querySelector('input[name="e-len"][value="vice"]').checked = true;
    dopocitejVraceni(); prepocti();
  });
  polOd.addEventListener('change', function () {
    if (polOd.value && (!polDo.value || polDo.value <= polOd.value)) dopocitejVraceni();
    vykresliTermin(); srovnejDelku(); prepocti();
  });
  polDo.addEventListener('change', function () { vykresliTermin(); srovnejDelku(); prepocti(); });

  /* ---------- kalendář ---------- */
  var MES = ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'];
  var cal = document.createElement('div');
  cal.className = 'e-cal';
  cal.hidden = true;
  cal.setAttribute('role', 'dialog');
  cal.setAttribute('aria-label', 'Výběr dne');
  document.body.appendChild(cal);
  var calPole = null, calMes = null, bubTimer = null;

  function calDuvod(v, dnes) {
    var co = calPole === 'od' ? 'vyzvednout' : 'vracet';
    if (v < dnes) return 'Tento den už je pryč';
    var x = v.split('-').map(Number), wd = new Date(x[0], x[1] - 1, x[2]).getDay();
    if (wd === 0 || wd === 6 || svatek(v)) return 'Soboty, neděle a svátky nelze motocykl ' + co;
    if (!pracovni(v)) return 'V tento den máme zavřeno, motocykl nelze ' + co;
    if (calPole === 'do' && polOd.value && v <= polOd.value) return 'Vrácení musí být až po vyzvednutí';
    return '';
  }
  function calKresli() {
    var dnes = iso(new Date()), od = polOd.value, doo = polDo.value, sel = document.getElementById('e-' + calPole).value;
    var y = calMes.getFullYear(), mo = calMes.getMonth();
    var posun = (new Date(y, mo, 1).getDay() + 6) % 7, pocet = new Date(y, mo + 1, 0).getDate();
    var ted = new Date();
    var h = '<div class="e-cal__top"><button type="button" data-k="-1" aria-label="Předchozí měsíc"' +
      (new Date(y, mo, 1) <= new Date(ted.getFullYear(), ted.getMonth(), 1) ? ' disabled' : '') + '>&lsaquo;</button>' +
      '<b>' + MES[mo] + ' ' + y + '</b>' +
      '<button type="button" data-k="1" aria-label="Další měsíc">&rsaquo;</button></div>';
    h += '<div class="e-cal__co">' + (calPole === 'od' ? 'Vyzvednutí' : 'Vrácení') + '</div><div class="e-cal__g">';
    h += ['po', 'út', 'st', 'čt', 'pá', 'so', 'ne'].map(function (d) { return '<i>' + d + '</i>'; }).join('');
    for (var i = 0; i < posun; i++) h += '<span></span>';
    for (var d = 1; d <= pocet; d++) {
      var v = iso(new Date(y, mo, d)), duvod = calDuvod(v, dnes), zak = !!duvod;
      var cls = [zak ? 'je-off' : '', v === sel ? 'je-sel' : '',
        (od && doo && v > od && v < doo) ? 'je-in' : '',
        ((v === od || v === doo) && v !== sel) ? 'je-kraj' : '',
        v === dnes ? 'je-dnes' : ''].filter(Boolean).join(' ');
      h += '<button type="button" data-v="' + v + '" class="' + cls + '"' +
        (zak ? ' aria-disabled="true" data-duvod="' + duvod + '"' : '') + '>' + d + '</button>';
    }
    h += '</div><div class="e-cal__bub" hidden></div>' +
      '<div class="e-cal__pata">Vyzvednutí i vrácení jen v pracovní dny. Víkend: pátek až pondělí.</div>';
    cal.innerHTML = h;
  }
  function calBublina(btn) {
    var b = cal.querySelector('.e-cal__bub');
    if (!b) return;
    b.textContent = btn.dataset.duvod;
    b.hidden = false;
    var r = btn.getBoundingClientRect(), k = cal.getBoundingClientRect();
    var w = b.offsetWidth, left = Math.max(6, Math.min(r.left - k.left + r.width / 2 - w / 2, k.width - w - 6));
    b.style.left = left + 'px';
    b.style.top = (r.top - k.top - b.offsetHeight - 8) + 'px';
    b.style.setProperty('--sipka', (r.left - k.left + r.width / 2 - left) + 'px');
    btn.classList.add('je-bump');
    setTimeout(function () { btn.classList.remove('je-bump'); }, 350);
    clearTimeout(bubTimer);
    bubTimer = setTimeout(function () { b.hidden = true; }, 2800);
  }
  function calOtevri(btn) {
    calPole = btn.dataset.for;
    var v = document.getElementById('e-' + calPole).value || (calPole === 'do' && polOd.value) || iso(new Date());
    var x = v.split('-').map(Number);
    calMes = new Date(x[0], x[1] - 1, 1);
    calKresli();
    cal.hidden = false;
    if (matchMedia('(max-width: 749px)').matches) { cal.style.left = ''; cal.style.top = ''; }
    else {
      var r = btn.getBoundingClientRect();
      cal.style.left = Math.min(r.left + scrollX, scrollX + innerWidth - cal.offsetWidth - 12) + 'px';
      cal.style.top = (r.bottom + scrollY + 6) + 'px';
    }
    [].forEach.call(document.querySelectorAll('.e-dbtn'), function (b) { b.classList.toggle('je-open', b === btn); });
  }
  function calZavri() {
    cal.hidden = true;
    [].forEach.call(document.querySelectorAll('.e-dbtn'), function (b) { b.classList.remove('je-open'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.e-dbtn');
    if (b) {
      e.preventDefault();
      if (!cal.hidden && b.classList.contains('je-open')) calZavri(); else calOtevri(b);
      return;
    }
    if (!cal.hidden && !e.target.closest('.e-cal')) calZavri();
  });
  cal.addEventListener('click', function (e) {
    e.stopPropagation();
    var k = e.target.closest('[data-k]');
    if (k) { calMes = new Date(calMes.getFullYear(), calMes.getMonth() + (+k.dataset.k), 1); calKresli(); return; }
    var d = e.target.closest('[data-v]');
    if (!d) return;
    if (d.dataset.duvod) { calBublina(d); return; }
    var inp = document.getElementById('e-' + calPole);
    inp.value = d.dataset.v;
    calZavri();
    inp.dispatchEvent(new Event('change'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cal.hidden) calZavri(); });

  /* ---------- přepočet ---------- */
  function prepocti() {
    var d = delka(), n = pocetDni(), dni = n;
    var radky = [], celkem = 0;
    var popis = d === 'den' ? 'Půjčení na 1 den' : d === 'vikend' ? 'Víkend (pá–po)' : 'Půjčení na ' + dnyTxt(n);
    var zaklad = (d === 'den' ? C.den : d === 'vikend' ? C.vikend : C.den * n) * ks;
    radky.push([popis + (ks > 1 ? ' · ' + ks + ' ks' : ''), zaklad, '']);
    celkem += zaklad;
    if (d === 'vice') {
      var r = sleva(n);
      if (r) {
        var sl = -Math.round(zaklad * r);
        radky.push(['Sleva za více dní −' + Math.round(r * 100) + ' %', sl, 'je-sleva']);
        celkem += sl;
      }
    }
    if (ks > 1 && setKsZapnut) {
      var pocetSetu = ks - 1;
      var vSet = SETP * dni * pocetSetu;
      radky.push(['Set výstroje ×' + pocetSetu + ' pro další jezdce, ' + dnyTxt(dni), vSet, '']);
      celkem += vSet;
    }
    var cv = cenaVystroje();
    if (cv.celySet) {
      var vs = SETP * dni;
      radky.push(['Celý set výstroje ×' + dnyTxt(dni), vs, '']);
      celkem += vs;
    } else {
      vybrano.forEach(function (id) {
        var v = cenaKusu(id) * dni;
        radky.push([nazevKusu(id) + ' ×' + dnyTxt(dni), v, '']);
        celkem += v;
      });
    }
    var detske = [].filter.call(document.querySelectorAll('.e-kalk__detska:checked'), function () { return true; });
    detske.forEach(function (c) {
      var v = cenaKusu(c.value) * dni;
      radky.push([nazevKusu(c.value) + ' ×' + dnyTxt(dni), v, '']);
      celkem += v;
    });
    var voz = document.getElementById('e-vozik').checked;
    if (voz) {
      var vv = (d === 'vikend' && C.vozik.pw) ? C.vozik.pw : C.vozik.p * dni;
      radky.push([C.vozik.n + (d === 'vikend' ? ' (víkend)' : ' ×' + dnyTxt(dni)), vv, '']);
      celkem += vv;
    }
    var kauce = C.kauce * ks + (voz ? C.vozik.kauce : 0);

    document.getElementById('e-kalk-tab').innerHTML = radky.map(function (r) {
      return '<tr class="' + r[2] + '"><td>' + r[0] + '</td><td>' + (r[1] < 0 ? '−' + kc(-r[1]) : kc(r[1])) + ' Kč</td></tr>';
    }).join('');
    document.getElementById('e-kalk-celkem').textContent = kc(celkem) + ' Kč';
    document.getElementById('e-kalk-kauce').textContent = '+ vratná kauce ' + kc(kauce) + ' Kč v hotovosti';

    /* souhrn výstroje */
    var gs = document.getElementById('e-gear-souhrn');
    if (!vybrano.length) gs.innerHTML = 'Zatím bez výstroje.';
    else if (cv.celySet) gs.innerHTML = '<b>Celý set: ' + kc(cv.set) + ' Kč / den</b> · ušetříte ' + kc(cv.jednotlive - cv.set) + ' Kč';
    else gs.innerHTML = 'Vybráno ' + vybrano.length + ' ' + (vybrano.length === 1 ? 'kus' : vybrano.length < 5 ? 'kusy' : 'kusů') +
      ': <b>' + kc(cv.zaDen) + ' Kč / den</b>' +
      (cv.jednotlive >= cv.set ? ' <span class="e-upsell">· celý set vyjde ' + (cv.jednotlive === cv.set ? 'stejně' : 'levněji (' + kc(cv.set) + ' Kč)') + '</span>' : '');
    document.getElementById('e-gear-set').hidden = cv.celySet;
    document.getElementById('e-gear-zrus').hidden = !vybrano.length;

    /* přenos do poptávky */
    var terminTxt = '';
    if (polOd.value || polDo.value) {
      var dn = (polOd.value && polDo.value) ? Math.round((new Date(polDo.value) - new Date(polOd.value)) / 864e5) : 0;
      terminTxt = (fmtD(polOd.value) || '?') + ' – ' + (fmtD(polDo.value) || '?') + (dn > 0 ? ' (' + dnyTxt(dn) + ')' : '');
    }
    var termEl = document.getElementById('e-f-termin');
    termEl.innerHTML = terminTxt ? '<b>' + terminTxt + '</b>' :
      '<span class="e-pj__napoveda">Zatím nevybraný. <a href="#kalkulacka">Vyberte ho v kalkulačce</a>, nebo ho napište do zprávy.</span>';
    var sestava = (terminTxt ? 'Termín: ' + terminTxt + '\n' : '') +
      'Motorka: ' + C.nazev + (ks > 1 ? ' ×' + ks : '') + '\n' +
      radky.map(function (r) { return r[0] + ': ' + (r[1] < 0 ? '−' + kc(-r[1]) : kc(r[1])) + ' Kč'; }).join('\n') +
      '\nCelkem orientačně: ' + kc(celkem) + ' Kč + kauce ' + kc(kauce) + ' Kč';
    document.getElementById('e-f-sestava').textContent = sestava;
    document.getElementById('e-h-sestava').value = sestava;
    document.getElementById('e-h-termin').value = terminTxt || '(nevybráno)';
    document.getElementById('e-h-motorka').value = C.nazev + (ks > 1 ? ' ×' + ks : '');
    document.getElementById('e-h-delka').value = popis;
    document.getElementById('e-h-vystroj').value = cv.celySet ? 'celý set' :
      (vybrano.length ? vybrano.map(nazevKusu).join(', ') : 'bez výstroje') +
      (detske.length ? ' + ' + detske.map(function (c) { return nazevKusu(c.value); }).join(', ') : '') +
      (ks > 1 && setKsZapnut ? ' + set pro další jezdce ×' + (ks - 1) : '');
    document.getElementById('e-h-prislusenstvi').value = voz ? C.vozik.n : 'nic';
    document.getElementById('e-h-cena').value = kc(celkem) + ' Kč (orientačně) · kauce ' + kc(kauce) + ' Kč';
    document.getElementById('e-velikosti').hidden = !(vybrano.length || detske.length || (ks > 1 && setKsZapnut));
  }

  [].forEach.call(document.querySelectorAll('.e-kalk__detska, #e-vozik'), function (c) { c.addEventListener('change', prepocti); });

  /* ---------- kontrola poptávky ---------- */
  var form = document.getElementById('pujcovna-poptavka');
  if (form) {
    form.addEventListener('submit', function (e) {
      var chyba = document.getElementById('e-f-chyba');
      function stop(t) { e.preventDefault(); chyba.textContent = t; }
      var chybi = ['contact[name]', 'contact[phone]', 'contact[email]'].filter(function (n) {
        var el = form.querySelector('[name="' + n + '"]');
        return el && !el.value.trim();
      });
      if (chybi.length) return stop('Vyplňte prosím jméno, telefon a e-mail.');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.querySelector('[name="contact[email]"]').value.trim())) return stop('Zkontrolujte prosím e-mail.');
      if (!document.getElementById('e-souhlas').checked) return stop('Potvrďte prosím souhlas se zpracováním údajů.');
      var hp = form.querySelector('[name="web"]');
      if (hp && hp.value) return stop('Formulář se nepodařilo odeslat.');
      var tch = terminChyby();
      if (tch.length) {
        vykresliTermin();
        stop('Zkontrolujte prosím termín v kalkulačce: ' + tch[0]);
        document.getElementById('kalkulacka').scrollIntoView({ block: 'start', behavior: 'smooth' });
        return;
      }
      chyba.textContent = '';
    });
  }

  vykresliKs();
  vykresliTermin();
  prepocti();
})();
